import { getMatchRepairshopsById } from '@src/api/repairShopApi'
import { IUserData } from '@src/components/UserInfo'
import { RepairShopSearchDto } from '@src/model/repairShopDom'
import { getErrorPath } from '@src/utils/errorPathUtils'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export default function useRepairShopMatch(uuid: string | undefined) {
  const [loading, setLoading] = useState<boolean>(true)
  const [searchResult, setSearchResult] = useState<RepairShopSearchDto | null>(
    null,
  )
  const [userData, setUserData] = useState<IUserData>({
    phoneNumber: '',
    messageToRepairShop: '',
    selectedRepairShopMatchId: NaN,
    registrationNumber: '',
  })

  const navigate = useNavigate()
  const { selection } = useParams()

  if (!uuid) {
    navigate(getErrorPath(uuid))
  }

  const selectedRepairShop = searchResult
    ? searchResult.results.find(
        (result) => result.matchId === Number(selection),
      )
    : null

  useEffect(() => {
    getMatchRepairshopsById(uuid)
      .then((data) => setSearchResult(data))
      .catch((error) => {
        navigate(getErrorPath(uuid, error.status))
      })
      .finally(() => setLoading(false))
  }, [uuid, navigate])

  useEffect(() => {
    setUserData((prevState) => ({
      ...prevState,
      phoneNumber: searchResult?.phoneNumber || '',
      selectedRepairShopMatchId: Number(selection),
      registrationNumber: searchResult?.vehicle.registrationNumber || '',
    }))
  }, [selectedRepairShop, searchResult, selection])

  return {
    searchResult,
    selectedRepairShop,
    loading,
    setLoading,
    userData,
    setUserData,
  }
}
